import MediaDetailView from '@/pages/detail/components/MediaDetailView';

export default function TvDetail() {
  return <MediaDetailView expectedKind="tv" />;
}